<template>
  <a-card>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="20">
          <a-col :span="10">
            <a-form-item label='集合时间'>
              <a-date-picker format="YYYY-MM-DD"
                             value-format="YYYY-MM-DD"
                             v-model="queryForm.setOfStartTime"
                             placeholder="开始日期"/>
              <span style="width: 6%;display: inline-block;text-align: center">至</span>
              <a-date-picker format="YYYY-MM-DD"
                             value-format="YYYY-MM-DD"
                             v-model="queryForm.setOfEndDate"
                             placeholder="结束日期"/>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label='活动类型'>
              <dict-cascader dict-key="BID_ZJSZYT"
                             style="width: 100%"
                             placeholder="活动类型"
                             v-model="queryForm.applyType"></dict-cascader>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label='状态'>
              <dict-cascader dict-key="extract_expert_flag_search"
                             style="width: 100%"
                             placeholder="状态"
                             v-model="queryForm.expertFlag"></dict-cascader>
            </a-form-item>
          </a-col>
          <a-col :span="4"
                 class="footer-button">
            <a-form-item :wrapperCol="{ span: 23 }"
                         style="text-align: center">
              <a-button type="primary"
                        @click="onSearch">查询
              </a-button>
              <a-button @click="reset"
                        style="margin-left: 20px">重置
              </a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table ref="table"
             :columns="columns"
             :data="loadData"
             :rowKey="record => record.id"
             :pagination="{ showTotal: (total) => `共 ${total} 条` }">
      <template slot="applyType"
                slot-scope="record">
        {{ record.applyTypeText }}
      </template>
      <template slot="expertFlag"
                slot-scope="record">
        <a-popover placement="left" v-if="extractExpertFlagEnumComputed.LEAVE[0] === record.expertFlag"
                   title="请假信息">
          <template slot="content">
            <p>请假时间：{{ record.leaveDate | dayjs('YYYY-MM-DD')}}</p>
            <p>请假原因：{{record.expertFlagReason || '未填写'}}</p>
          </template>
          <a-icon type="info-circle"/>
        </a-popover>
        <a-tag style="margin-left: 2px" :color="extractExpertFlagEnumComputed.getValOrCol(record.expertFlag).color">
          {{ record.expertFlagText }}
        </a-tag>
      </template>
    </s-table>
  </a-card>
</template>

<script>
import STable from '@/components/Table'
import DictCascader from '@/components/dict/DictCascader'
import { QueryExpertAllWorkRecordByUserIdList } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import { ExtractExpertFlagEnum } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'

const columns = [
  { title: '通知时间', width: 100, dataIndex: 'addDate' },
  { title: '活动类型', width: 100, scopedSlots: { customRender: 'applyType' } },
  { title: '预计时长', width: 100, dataIndex: 'reviewDuration' },
  { title: '集合时间', width: 100, dataIndex: 'setOfTime' },
  { title: '集合地点', width: 250, dataIndex: 'setOfAddress' },
  {
    title: '携带资料', width: 150, dataIndex: 'information', customRender: (text) => {
      return text ? text : '无'
    }
  },
  { title: '状态', align: 'center', width: 100, scopedSlots: { customRender: 'expertFlag' } },
]
export default {
  name: 'SelectExpertApplyIndex',
  components: {
    STable,
    DictCascader
  },
  data () {
    return {
      columns,
      queryForm: {
        expertFlag: '',
        setOfStartTime: undefined,
        setOfEndTime: undefined
      },
      loadData: (parameter) => {
        const data = { ...this.queryForm, ...parameter }
        return QueryExpertAllWorkRecordByUserIdList(data)
      },
    }
  },
  computed: {
    extractExpertFlagEnumComputed () {
      return ExtractExpertFlagEnum
    }
  },
  methods: {
    reset () {
      this.queryForm = {
        expertFlag: '',
        setOfStartTime: undefined,
        setOfEndTime: undefined
      }
      this.onSearch()
    },
    onSearch () {
      this.$refs.table.refresh(true)
    },
    onView (id) {
      this.$router.push({
        path: '/selectExpertApply/view?id=' + id
      })
    },
  }
}
</script>

<style lang="less" scoped>
.ant-calendar-picker {
  width: 47% !important;
}
</style>
